<template>
<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">
<path class="st0" d="M167,105c0,3.3-2.7,6-6,6H79.5l19.8,19.8c1.3,1.3,2,3.1,1.8,4.9c-0.2,2.3-1.8,4.3-4,5.1
    c-2.2,0.8-4.7,0.2-6.3-1.5l-30-30c-2.3-2.3-2.3-6.1,0-8.4l30-30c1.1-1.2,2.6-1.9,4.3-1.9c1.6,0,3.2,0.6,4.3,1.7
    c1.1,1.1,1.8,2.7,1.8,4.3c0,1.6-0.7,3.2-1.8,4.3L79.5,99H161C164.3,99,167,101.7,167,105L167,105z M53,147c0,3.3-2.7,6-6,6
    s-6-2.7-6-6V63c0-3.3,2.7-6,6-6c3.3,0,6,2.7,6,6V147z"/>
</svg>
</template>

<script>
export default {
    name: 'IconRetractSideNav',
}
</script>

<style lang="scss" scoped>

</style>